import { Autocomplete, Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCurrentModDetails,
  selectInitiators,
  selectIsUndoModal,
} from 'store/redux-store/placement-mods/selectors';
import { trackPromise } from 'react-promise-tracker';
import { getAllEmployees } from 'app/services/TaskServices/TaskServices';
import { GenerateAllEmployeeObjectInitated } from '@AMIEWEB/Tasks/CreateTask/FormatData';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { startDateModStyles } from './StartDateMod.styles';

export const InitiatedBy = ({ options, isModEdit }: { options: any; isModEdit: boolean }) => {
  const { control, setValue, formState: { errors } } = useFormContext();
  const { classes } = startDateModStyles();
  const initiatedBy = 'initiatedBy';
  const dispatch = useDispatch();
  const initiatedById = 'initiatedByUserId';
  const initiators = useSelector(selectInitiators);
  const isUndoModal = useSelector(selectIsUndoModal);
  const [userOptions, setOptions] = useState<any[]>([]);
  const [initialOptions, setInitialOptions] = useState<any[]>([]);
  const [defaultOption, setDefaultOption] = useState<any>([]);
  const selectedModsDetails = useSelector(selectCurrentModDetails);

  const onSelectionChange = value => {
    setValue(initiatedBy, value?.label);
    setValue(initiatedById, value?.id);
  };

  const fetchEmployeeDetails = async (searchKey: string) => {
    if (searchKey && searchKey?.length > 2) {
      await getAllEmployees(searchKey).then(data => {
        const formatData = GenerateAllEmployeeObjectInitated(data);
        setOptions(prevData => formatData);
      });
    } else {
      setOptions(initialOptions);
    }
  };

  useEffect(() => {
    if (initiators?.length > 0) {
      const formattedOption = initiators?.map(val => ({ label: val.Description, id: val.ID }));
      setOptions(formattedOption);
      setInitialOptions(formattedOption);
    }
  }, [initiators]);

  useEffect(() => {
    if (selectedModsDetails?.initiatedByUserId && selectedModsDetails?.initiatedBy) {
      const defaultVal = { label: selectedModsDetails?.initiatedBy, id: selectedModsDetails?.initiatedByUserId };
      setDefaultOption(defaultVal);
      dispatch(placementModsAction.setIsUndoModal(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedModsDetails, isUndoModal]);

  return (
    <Controller
      control={control}
      name={initiatedById}
      rules={{ required: true }}
      render={({ field: { onChange, ...rest } }) => (
        <Grid>
          <Autocomplete
            options={userOptions ?? []}
            getOptionLabel={option => option.label || ''}
            value={defaultOption}
            className={classes.autocompleteField}
            disabled={!isModEdit}
            onChange={(e, value) => {
              setDefaultOption(value);
              onSelectionChange(value);
              onChange(value?.id);
            }}
            onInputChange={(e, data) => {
              trackPromise(fetchEmployeeDetails(data), 'initiated-by');
            }}
            renderInput={params => (
              <TextField {...params} label={`Initiated By*`} variant="filled" error={!!errors?.initiatedById} />
            )}
          />
        </Grid>
      )}
    />
  );
};
